import { useState } from "react"; // Removed useEffect again
import apiClient from "./api/apiClient";
// Removed: import { Routes, Route, NavLink } from 'react-router-dom';
import "./App.css";
import LogViewer from "./components/LogViewer";
import PairingForm from "./components/PairingForm";
import PairingResult from "./components/PairingResult";
import ProductsManagement from "./components/ProductsManagement";

// Define type for recommended wine
interface RecommendedWine {
  product_id: number;
  name: string;
}

// Removed HomePage sub-component, logic moved back to App

function App() {
  const [suggestion, setSuggestion] = useState<string | null>(null);
  const [recommendedWines, setRecommendedWines] = useState<RecommendedWine[]>(
    []
  );
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleFormSubmit = async (query: string) => {
    setIsLoading(true);
    setError(null);
    setSuggestion(null);
    setRecommendedWines([]); // Clear previous recommendations

    try {
      const response = await apiClient.post("/api/pairing", { query });

      const data = response.data;
      setSuggestion(data.suggestion || "No suggestion text received."); // Handle missing suggestion text
      setRecommendedWines(data.recommendedWines || []); // Handle missing recommendations array
    } catch (err: any) {
      console.error("API call failed:", err);
      const errorMessage =
        err.response?.data?.error ||
        err.message ||
        "Failed to fetch pairing suggestion.";
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  // Initialize Materialize components that require JS (if any)
  // useEffect(() => { // M.AutoInit(); // Or initialize specific components // }, []);

  // useEffect(() => { // M.AutoInit(); // Or initialize specific components // }, []);

  return (
    <div>
      {/* Materialize Navbar */}
      <nav>
        <div className="nav-wrapper teal lighten-2">
          {/* Reverted NavLink to simple a tag or span if no navigation needed for logo */}
          <span className="brand-logo center">
            Assistente Abbinamento Bevande
          </span>
          {/* Navigation UL removed as routing is removed */}
        </div>
      </nav>

      {/* Main content container */}
      <div className="container" style={{ paddingTop: "20px" }}>
        {/* All components rendered directly */}
        <PairingForm onSubmit={handleFormSubmit} isLoading={isLoading} />
        <PairingResult
          suggestion={suggestion}
          error={error}
          recommendedWines={recommendedWines}
        />
        <hr style={{ margin: "30px 0" }} />
        <LogViewer />
        <hr style={{ margin: "30px 0" }} />
        <ProductsManagement />
      </div>
    </div>
  );
}

export default App;
